// Handshake token bridge. Laravel sends the token once the iframe loads;
// we store it in module state and attach it to every Worker request.

let handshakeToken: string | null = null;
const listeners = new Set<(token: string) => void>();

export function installHandshakeListener(): void {
  window.addEventListener('message', (event) => {
    if (event.data?.type === 'oop:handshake' && typeof event.data.token === 'string') {
      const token: string = event.data.token;
      handshakeToken = token;
      for (const fn of listeners) fn(token);
    }
  });

  // Tell the parent we're ready so it retransmits if we booted after its
  // initial post. Safe no-op when running standalone (no parent).
  if (window.parent !== window) {
    window.parent.postMessage({ type: 'oop:ready' }, '*');
  }
}

export function getHandshakeToken(): string | null {
  return handshakeToken;
}

export function onHandshake(fn: (token: string) => void): () => void {
  listeners.add(fn);
  if (handshakeToken) fn(handshakeToken);
  return () => {
    listeners.delete(fn);
  };
}

export function notifyTicketCreated(story: { id: number; app_url: string }): void {
  if (window.parent !== window) {
    window.parent.postMessage(
      { type: 'oop:ticket-created', id: story.id, url: story.app_url },
      '*',
    );
  }
}
